import { styleMap } from '~/lib/bn-lit-element';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './bin-profile';
import '../../common/bn-icon';
import '../props/bin-name';
import './bin-level-metric';

class ChildBinProfiles extends LitEntity {
  constructor() {
    super();
    this.childBinHeights = {};
    this.maxHeight = .1;
  }

  static get properties() {
    return {
      selectedHref: { type: String },
      childBins: { type: Array, attribute: false },
      maxHeight: { type: Number, attribute: false },
      small: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
        overflow-x: auto;
        overflow-y: hidden;
        width: 100%;
      }
      .bin-list {
        display: flex;
        height: 100%;
        align-items: center;
      }
      .profile-container {
        display: inline-flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-end;
        text-decoration: none;
        height: 100%;
        min-width: 80px;
        flex-grow: 1;
        padding: 5px;
        box-sizing: border-box;
        border-bottom: 3px solid transparent;
        color: var(--blue-60);
      }
      .inner-container {
        padding: 0 10px;
        height: calc(100% - 2em);
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
      :host([small]) .inner-container {
        height: 100%;
      }
      bin-level-metric,
      bin-name {
        width: 100%;
        text-align: center;
        font-size: .75em;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex-grow: 1;
        padding-bottom: 2px;
      }
      bin-level-metric {
        color: var(--yellow-30);
        font-size: .65em;
        padding-bottom: 5px;
      }
      bin-name {
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      :host([small]) .profile-container {
        height: 50px;
        padding: 3px;
        min-width: 40px;
      }
      .profile-container + .profile-container {
        margin-left: 6px;
      }
      .profile-container[selected] {
        border-bottom: 3px solid var(--blue-50);
        background-color: none;
      }
      .profile-container:hover {
        background-color: var(--hover-color);
        border-bottom: 3px solid var(--blue-60);
        cursor: pointer;
      }
    `];
  }

  render() {
    if (!this.childBins) {
      return html``;
    }
    return html`
      <div class="bin-list">
        ${this.childBins.map((binLink) => this._renderBin(binLink))}
      </div>
    `;
  }

  _renderBin(binLink) {
    const binHeight = this.childBinHeights[binLink.href];
    const heightPercent = binHeight > 0 ? binHeight / this.maxHeight * 100 : 100;
    return html`
      <a class="profile-container" href="/bins/show/overview?binId=${encodeURIComponent(binLink.href)}" ?selected="${this.selectedHref === binLink.href}">
        ${renderIf(!this.small, html`
          <bin-name .href="${binLink.href}"></bin-name>
          <bin-level-metric .href="${binLink.href}"></bin-level-metric>
        `)}
        <div class="inner-container">
          <bin-profile
            .href="${binLink.href}"
            @update="${this._onBinUpdate}"
            style="${styleMap({ height: `${heightPercent}%` })}"
          ></bin-profile>
        </div>
      </a>
    `;
  }

  _onBinUpdate(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }
    const selfHref = entity.getLinkByRel('self').href;
    const { totalHeight } = entity.properties.dimensions;
    this.childBinHeights[selfHref] = totalHeight;
    this.maxHeight = totalHeight > this.maxHeight ? totalHeight : this.maxHeight;
    this.requestUpdate();
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.childBins = this.entity && this.entity.getSubEntitiesByRel('https://api.binsentry.com/rel/bin-aggregate-child');
  }
}

window.customElements.define('child-bin-profiles', ChildBinProfiles);
